
// import React, { useEffect } from 'react';
// import { connect } from 'react-redux';
// import { getelectiontype } from '../actions/electionAction';
// import { useSelector,useDispatch } from 'react-redux';

// const Election = (props) => {
//   const { getelectiontype, electiontypeList } = props;
//   const mystate = useSelector((state) => state.electiontypeList);
//   const dispatch = useDispatch();
//   useEffect(() => {
//     getelectiontype();
//   }, [getelectiontype]);

//   console.log("Election Data:", electiontypeList);

//   return (
//     <div>
//       <h1>Election List</h1>
//       <ul>
//         {electiontypeList && electiontypeList.map((election) => (
//           <li key={election.id}>
//             {election.name} ({election.year}) - Status: {election.is_active === 1 ? 'Active' : 'Inactive'}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// const mapStateToProps = (state) => ({
//   electiontypeList: state.elections.electiontypeList,
// });

// const mapDispatchToProps = {
//   getelectiontype
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Election);
// import React, { useState, useMemo } from 'react';

// const COLORS = {
//   primary: '#3B82F6',
//   primaryDark: '#1D4ED8',
//   secondary: '#64748B',
//   success: '#10B981',
//   danger: '#EF4444',
//   warning: '#F59E0B',
//   light: '#F8FAFC',
//   dark: '#1E293B',
//   border: '#E2E8F0',
//   text: '#475569',
//   textLight: '#94A3B8',
//   white: '#FFFFFF',
// };

// const ElectionList = () => {
//   const [searchQuery, setSearchQuery] = useState('');
//   const [addModalVisible, setAddModalVisible] = useState(false);
//   const [year, setYear] = useState('');
//   const [name, setName] = useState('');
//   const [status, setStatus] = useState('active');

//   const [editModalVisible, setEditModalVisible] = useState(false);
//   const [editingElection, setEditingElection] = useState(null);

//   const [filterModalVisible, setFilterModalVisible] = useState(false);
//   const [activeFilterType, setActiveFilterType] = useState('name');
//   const [filterValue, setFilterValue] = useState('');

//   const [electionTypes, setElectionTypes] = useState([
//     { id: 1, name: 'Presidential Election', year: 2024, is_active: 1 },
//     { id: 2, name: 'Local Council Election', year: 2023, is_active: 0 },
//     { id: 3, name: 'Senate Election', year: 2024, is_active: 1 },
//     { id: 4, name: 'State Governor Election', year: 2022, is_active: 0 },
//   ]);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Filtering logic for search and filter inputs
//   const filteredElections = useMemo(() => {
//     let data = Array.isArray(electionTypes) ? electionTypes : [];

//     if (searchQuery) {
//       const queryLower = searchQuery.toLowerCase();
//       data = data.filter(
//         (item) =>
//           item.name.toLowerCase().includes(queryLower) ||
//           item.year.toString().toLowerCase().includes(queryLower) ||
//           item.id.toString().toLowerCase().includes(queryLower)
//       );
//     }

//     if (filterValue) {
//       const filterLower = filterValue.toLowerCase().trim();
//       data = data.filter((item) => {
//         const valueToCompare = {
//           id: item.id.toString(),
//           name: item.name,
//           year: item.year.toString(),
//         }[activeFilterType];
//         return valueToCompare?.toLowerCase().includes(filterLower);
//       });
//     }

//     return data.sort((a, b) => b.id - a.id);
//   }, [searchQuery, electionTypes, activeFilterType, filterValue]);

//   // Handlers for modals and operations
//   const clearAddModal = () => {
//     setYear('');
//     setName('');
//     setStatus('active');
//     setAddModalVisible(false);
//   };

//   const handleClearFilter = () => {
//     setActiveFilterType('name');
//     setFilterValue('');
//     setFilterModalVisible(false);
//   };

//   const handleAddElection = () => {
//     if (!year.trim() || !name.trim()) {
//       alert('Error: Fields cannot be empty');
//       return;
//     }
//     if (!/^\d{4}$/.test(year)) {
//       alert('Error: Invalid year format');
//       return;
//     }
//     const newItem = {
//       id: Math.max(...electionTypes.map(e => e.id)) + 1,
//       name,
//       year: parseInt(year),
//       is_active: status === 'active' ? 1 : 0,
//     };
//     setElectionTypes([newItem, ...electionTypes]);
//     clearAddModal();
//   };

//   const handleDelete = (id) => {
//     if (window.confirm('Are you sure you want to delete this election?')) {
//       setElectionTypes(electionTypes.filter((item) => item.id !== id));
//     }
//   };

//   const handleEdit = (item) => {
//     setEditingElection({...item});
//     setEditModalVisible(true);
//   };

//   const handleUpdate = () => {
//     if (!editingElection.name.trim() || !editingElection.year.toString().trim()) {
//       alert('Error: Fields cannot be empty');
//       return;
//     }
//     if (!/^\d{4}$/.test(editingElection.year.toString())) {
//       alert('Error: Invalid year format');
//       return;
//     }
//     setElectionTypes(
//       electionTypes.map((item) =>
//         item.id === editingElection.id ? editingElection : item
//       )
//     );
//     setEditModalVisible(false);
//     setEditingElection(null);
//   };

//   const toggleStatus = (id) => {
//     setElectionTypes(
//       electionTypes.map((item) =>
//         item.id === id ? { ...item, is_active: item.is_active === 1 ? 0 : 1 } : item
//       )
//     );
//   };

//   const StatusBadge = ({ active }) => (
//     <span style={{
//       ...styles.statusBadge,
//       ...(active ? styles.statusActive : styles.statusInactive)
//     }}>
//       {active ? 'Active' : 'Inactive'}
//     </span>
//   );

//   const Modal = ({ visible, onClose, children, title }) => {
//     if (!visible) return null;
//     return (
//       <div style={styles.modalBackdrop}>
//         <div style={styles.modalView}>
//           <div style={styles.modalHeader}>
//             <h2 style={styles.modalTitle}>{title}</h2>
//             <button style={styles.closeButton} onClick={onClose}>
//               ×
//             </button>
//           </div>
//           {children}
//         </div>
//       </div>
//     );
//   };

//   const FilterTypeButton = ({ type, active, onClick }) => (
//     <button
//       onClick={onClick}
//       style={{
//         ...styles.filterTypeButton,
//         ...(active ? styles.filterTypeButtonActive : {}),
//       }}
//     >
//       {type.charAt(0).toUpperCase() + type.slice(1)}
//     </button>
//   );

//   return (
//     <div style={styles.container}>
//       <div style={styles.header}>
//         <div style={styles.headerContent}>
//           <h1 style={styles.title}>Election Management</h1>
//           <p style={styles.subtitle}>Manage and monitor all election types</p>
//         </div>
//         <button
//           onClick={() => setAddModalVisible(true)}
//           style={styles.addButton}
//         >
//           <span style={styles.addButtonIcon}>+</span>
//           Add Election
//         </button>
//       </div>

//       <div style={styles.controlsContainer}>
//         <div style={styles.searchContainer}>
//           <div style={styles.searchWrapper}>
//             <input
//               type="text"
//               placeholder="Search elections..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               style={styles.searchInput}
//             />
//             <span style={styles.searchIcon}>🔍</span>
//           </div>
//           <button
//             onClick={() => setFilterModalVisible(true)}
//             style={styles.filterButton}
//           >
//             <span style={styles.filterIcon}>⏷</span>
//             Filters
//           </button>
//         </div>
        
//         <div style={styles.statsContainer}>
//           <div style={styles.statItem}>
//             <span style={styles.statNumber}>{electionTypes.length}</span>
//             <span style={styles.statLabel}>Total</span>
//           </div>
//           <div style={styles.statItem}>
//             <span style={styles.statNumber}>
//               {electionTypes.filter(e => e.is_active === 1).length}
//             </span>
//             <span style={styles.statLabel}>Active</span>
//           </div>
//         </div>
//       </div>

//       {error && (
//         <div style={styles.errorContainer}>
//           <div style={styles.errorIcon}>⚠️</div>
//           <p style={styles.errorText}>Error: {error}</p>
//         </div>
//       )}

//       <div style={styles.tableContainer}>
//         {loading && filteredElections.length === 0 ? (
//           <div style={styles.loadingContainer}>
//             <div style={styles.spinner}></div>
//             <p>Loading elections...</p>
//           </div>
//         ) : filteredElections.length === 0 ? (
//           <div style={styles.emptyState}>
//             <div style={styles.emptyStateIcon}>📊</div>
//             <h3 style={styles.emptyStateTitle}>No elections found</h3>
//             <p style={styles.emptyStateText}>
//               {searchQuery || filterValue 
//                 ? 'Try adjusting your search or filter criteria' 
//                 : 'Get started by creating your first election'}
//             </p>
//             <button 
//               style={styles.emptyStateButton}
//               onClick={() => setAddModalVisible(true)}
//             >
//               Add Election
//             </button>
//           </div>
//         ) : (
//           <table style={styles.table}>
//             <thead style={styles.tableHeader}>
//               <tr>
//                 <th style={styles.tableHeaderCell}>ID</th>
//                 <th style={styles.tableHeaderCell}>Name</th>
//                 <th style={styles.tableHeaderCell}>Year</th>
//                 <th style={styles.tableHeaderCell}>Status</th>
//                 <th style={styles.tableHeaderCell}>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredElections.map((item) => (
//                 <tr key={item.id} style={styles.tableRow}>
//                   <td style={styles.tableCell}>
//                     <span style={styles.idBadge}>#{item.id}</span>
//                   </td>
//                   <td style={styles.tableCell}>
//                     <div style={styles.nameCell}>
//                       <span style={styles.nameText}>{item.name}</span>
//                     </div>
//                   </td>
//                   <td style={styles.tableCell}>
//                     <span style={styles.yearText}>{item.year}</span>
//                   </td>
//                   <td style={styles.tableCell}>
//                     <div style={styles.statusCell}>
//                       <StatusBadge active={item.is_active === 1} />
//                       <label style={styles.toggleSwitch}>
//                         <input
//                           type="checkbox"
//                           checked={item.is_active === 1}
//                           onChange={() => toggleStatus(item.id)}
//                           style={styles.toggleInput}
//                         />
//                         <span style={styles.toggleSlider}></span>
//                       </label>
//                     </div>
//                   </td>
//                   <td style={styles.tableCell}>
//                     <div style={styles.actionButtons}>
//                       <button 
//                         style={styles.editButton}
//                         onClick={() => handleEdit(item)}
//                         title="Edit"
//                       >
//                         Edit
//                       </button>
//                       <button
//                         style={styles.deleteButton}
//                         onClick={() => handleDelete(item.id)}
//                         title="Delete"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>

//       {/* Add Modal */}
//       <Modal visible={addModalVisible} onClose={clearAddModal} title="Create New Election">
//         <div style={styles.formGroup}>
//           <label style={styles.formLabel}>Election Year</label>
//           <input
//             type="number"
//             placeholder="Enter election year (e.g., 2024)"
//             maxLength={4}
//             value={year}
//             onChange={(e) => setYear(e.target.value)}
//             style={styles.formInput}
//           />
//         </div>
//         <div style={styles.formGroup}>
//           <label style={styles.formLabel}>Election Name</label>
//           <input
//             type="text"
//             placeholder="Enter election name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             style={styles.formInput}
//           />
//         </div>
//         <div style={styles.formGroup}>
//           <label style={styles.formLabel}>Status</label>
//           <select 
//             value={status} 
//             onChange={(e) => setStatus(e.target.value)} 
//             style={styles.formInput}
//           >
//             <option value="active">Active</option>
//             <option value="inactive">Inactive</option>
//           </select>
//         </div>
//         <div style={styles.modalActions}>
//           <button onClick={clearAddModal} style={styles.cancelButton}>
//             Cancel
//           </button>
//           <button onClick={handleAddElection} style={styles.saveButton}>
//             Create Election
//           </button>
//         </div>
//       </Modal>

//       {/* Edit Modal */}
//       <Modal visible={editModalVisible} onClose={() => setEditModalVisible(false)} title="Edit Election">
//         {editingElection && (
//           <>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Election Year</label>
//               <input
//                 type="number"
//                 placeholder="Enter election year"
//                 maxLength={4}
//                 value={editingElection.year}
//                 onChange={(e) =>
//                   setEditingElection({ ...editingElection, year: e.target.value })
//                 }
//                 style={styles.formInput}
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.formLabel}>Election Name</label>
//               <input
//                 type="text"
//                 placeholder="Enter election name"
//                 value={editingElection.name}
//                 onChange={(e) =>
//                   setEditingElection({ ...editingElection, name: e.target.value })
//                 }
//                 style={styles.formInput}
//               />
//             </div>
//             <div style={styles.modalActions}>
//               <button onClick={() => setEditModalVisible(false)} style={styles.cancelButton}>
//                 Cancel
//               </button>
//               <button onClick={handleUpdate} style={styles.saveButton}>
//                 Save Changes
//               </button>
//             </div>
//           </>
//         )}
//       </Modal>

//       {/* Filter Modal */}
//       <Modal visible={filterModalVisible} onClose={() => setFilterModalVisible(false)} title="Filter Elections">
//         <div style={styles.formGroup}>
//           <label style={styles.formLabel}>Filter By</label>
//           <div style={styles.filterTypeContainer}>
//             {['name', 'id', 'year'].map((type) => (
//               <FilterTypeButton
//                 key={type}
//                 type={type}
//                 active={activeFilterType === type}
//                 onClick={() => setActiveFilterType(type)}
//               />
//             ))}
//           </div>
//         </div>
//         <div style={styles.formGroup}>
//           <label style={styles.formLabel}>Filter Value</label>
//           <input
//             type={activeFilterType !== 'name' ? 'number' : 'text'}
//             placeholder={`Enter ${activeFilterType} to filter...`}
//             value={filterValue}
//             onChange={(e) => setFilterValue(e.target.value)}
//             style={styles.formInput}
//           />
//         </div>
//         <div style={styles.modalActions}>
//           <button onClick={handleClearFilter} style={styles.cancelButton}>
//             Clear Filters
//           </button>
//           <button onClick={() => setFilterModalVisible(false)} style={styles.saveButton}>
//             Apply Filters
//           </button>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// const styles = {
//   container: {
//     minHeight: '100vh',
//     backgroundColor: '#F8FAFC',
//     padding: '32px',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//   },
//   header: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     marginBottom: '32px',
//   },
//   headerContent: {
//     flex: 1,
//   },
//   title: {
//     fontSize: '32px',
//     fontWeight: '700',
//     color: COLORS.dark,
//     margin: '0 0 8px 0',
//   },
//   subtitle: {
//     fontSize: '16px',
//     color: COLORS.textLight,
//     margin: 0,
//   },
//   addButton: {
//     backgroundColor: COLORS.primary,
//     color: COLORS.white,
//     border: 'none',
//     borderRadius: '8px',
//     padding: '12px 24px',
//     fontSize: '14px',
//     fontWeight: '600',
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     transition: 'all 0.2s ease',
//     boxShadow: '0 1px 3px rgba(59, 130, 246, 0.2)',
//   },
//   addButtonIcon: {
//     fontSize: '18px',
//     fontWeight: 'bold',
//   },
//   controlsContainer: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '24px',
//     gap: '24px',
//   },
//   searchContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     flex: 1,
//   },
//   searchWrapper: {
//     position: 'relative',
//     flex: 1,
//     maxWidth: '400px',
//   },
//   searchInput: {
//     width: '100%',
//     padding: '12px 16px 12px 40px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '8px',
//     fontSize: '14px',
//     backgroundColor: COLORS.white,
//     boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
//   },
//   searchIcon: {
//     position: 'absolute',
//     left: '12px',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     color: COLORS.textLight,
//   },
//   filterButton: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '8px',
//     padding: '12px 16px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '8px',
//     backgroundColor: COLORS.white,
//     color: COLORS.text,
//     fontSize: '14px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   filterIcon: {
//     fontSize: '16px',
//   },
//   statsContainer: {
//     display: 'flex',
//     gap: '16px',
//   },
//   statItem: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     padding: '16px 20px',
//     backgroundColor: COLORS.white,
//     borderRadius: '8px',
//     border: `1px solid ${COLORS.border}`,
//     minWidth: '80px',
//   },
//   statNumber: {
//     fontSize: '20px',
//     fontWeight: '700',
//     color: COLORS.dark,
//   },
//   statLabel: {
//     fontSize: '12px',
//     color: COLORS.textLight,
//     fontWeight: '500',
//   },
//   tableContainer: {
//     backgroundColor: COLORS.white,
//     borderRadius: '12px',
//     border: `1px solid ${COLORS.border}`,
//     overflow: 'hidden',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//   },
//   table: {
//     width: '100%',
//     borderCollapse: 'collapse',
//   },
//   tableHeader: {
//     backgroundColor: '#F8FAFC',
//     borderBottom: `1px solid ${COLORS.border}`,
//   },
//   tableHeaderCell: {
//     padding: '16px 20px',
//     textAlign: 'left',
//     fontSize: '12px',
//     fontWeight: '600',
//     color: COLORS.textLight,
//     textTransform: 'uppercase',
//     letterSpacing: '0.05em',
//   },
//   tableRow: {
//     borderBottom: `1px solid ${COLORS.border}`,
//     transition: 'background-color 0.2s ease',
//   },
//   tableRowHover: {
//     backgroundColor: '#F8FAFC',
//   },
//   tableCell: {
//     padding: '20px',
//     fontSize: '14px',
//     color: COLORS.text,
//   },
//   idBadge: {
//     backgroundColor: '#F1F5F9',
//     color: COLORS.text,
//     padding: '4px 8px',
//     borderRadius: '4px',
//     fontSize: '12px',
//     fontWeight: '600',
//   },
//   nameCell: {
//     display: 'flex',
//     alignItems: 'center',
//   },
//   nameText: {
//     fontWeight: '500',
//     color: COLORS.dark,
//   },
//   yearText: {
//     fontWeight: '600',
//     color: COLORS.dark,
//   },
//   statusCell: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//   },
//   statusBadge: {
//     padding: '4px 8px',
//     borderRadius: '4px',
//     fontSize: '12px',
//     fontWeight: '600',
//   },
//   statusActive: {
//     backgroundColor: '#D1FAE5',
//     color: '#065F46',
//   },
//   statusInactive: {
//     backgroundColor: '#FEE2E2',
//     color: '#991B1B',
//   },
//   toggleSwitch: {
//     position: 'relative',
//     display: 'inline-block',
//     width: '44px',
//     height: '24px',
//   },
//   toggleInput: {
//     opacity: 0,
//     width: 0,
//     height: 0,
//   },
//   toggleSlider: {
//     position: 'absolute',
//     cursor: 'pointer',
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: '#CBD5E1',
//     transition: '0.4s',
//     borderRadius: '24px',
//   },
//   toggleSliderBefore: {
//     position: 'absolute',
//     content: '""',
//     height: '16px',
//     width: '16px',
//     left: '4px',
//     bottom: '4px',
//     backgroundColor: COLORS.white,
//     transition: '0.4s',
//     borderRadius: '50%',
//   },
//   actionButtons: {
//     display: 'flex',
//     gap: '8px',
//   },
//   editButton: {
//     padding: '8px 16px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '6px',
//     backgroundColor: COLORS.white,
//     color: COLORS.text,
//     fontSize: '12px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   deleteButton: {
//     padding: '8px 16px',
//     border: `1px solid ${COLORS.danger}`,
//     borderRadius: '6px',
//     backgroundColor: COLORS.white,
//     color: COLORS.danger,
//     fontSize: '12px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   modalBackdrop: {
//     position: 'fixed',
//     top: 0,
//     left: 0,
//     width: '100vw',
//     height: '100vh',
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     zIndex: 1000,
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     padding: '20px',
//   },
//   modalView: {
//     backgroundColor: COLORS.white,
//     borderRadius: '12px',
//     width: '100%',
//     maxWidth: '480px',
//     boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
//   },
//   modalHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '24px 24px 0 24px',
//   },
//   modalTitle: {
//     fontSize: '20px',
//     fontWeight: '600',
//     color: COLORS.dark,
//     margin: 0,
//   },
//   closeButton: {
//     background: 'none',
//     border: 'none',
//     fontSize: '24px',
//     cursor: 'pointer',
//     color: COLORS.textLight,
//     padding: 0,
//     width: '32px',
//     height: '32px',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     borderRadius: '4px',
//     transition: 'background-color 0.2s ease',
//   },
//   formGroup: {
//     marginBottom: '20px',
//     padding: '0 24px',
//   },
//   formLabel: {
//     display: 'block',
//     marginBottom: '8px',
//     fontSize: '14px',
//     fontWeight: '500',
//     color: COLORS.dark,
//   },
//   formInput: {
//     width: '100%',
//     padding: '12px 16px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '8px',
//     fontSize: '14px',
//     backgroundColor: COLORS.white,
//     boxSizing: 'border-box',
//     transition: 'border-color 0.2s ease',
//   },
//   modalActions: {
//     display: 'flex',
//     gap: '12px',
//     padding: '24px',
//     borderTop: `1px solid ${COLORS.border}`,
//   },
//   cancelButton: {
//     flex: 1,
//     padding: '12px 16px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '8px',
//     backgroundColor: COLORS.white,
//     color: COLORS.text,
//     fontSize: '14px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   saveButton: {
//     flex: 1,
//     padding: '12px 16px',
//     border: 'none',
//     borderRadius: '8px',
//     backgroundColor: COLORS.primary,
//     color: COLORS.white,
//     fontSize: '14px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
//   filterTypeContainer: {
//     display: 'flex',
//     gap: '8px',
//   },
//   filterTypeButton: {
//     flex: 1,
//     padding: '12px 16px',
//     border: `1px solid ${COLORS.border}`,
//     borderRadius: '8px',
//     backgroundColor: COLORS.white,
//     color: COLORS.text,
//     fontSize: '14px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//     textAlign: 'center',
//   },
//   filterTypeButtonActive: {
//     backgroundColor: COLORS.primary,
//     borderColor: COLORS.primary,
//     color: COLORS.white,
//   },
//   errorContainer: {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '12px',
//     padding: '16px 20px',
//     backgroundColor: '#FEF2F2',
//     border: `1px solid ${COLORS.danger}`,
//     borderRadius: '8px',
//     marginBottom: '24px',
//   },
//   errorIcon: {
//     fontSize: '16px',
//   },
//   errorText: {
//     color: COLORS.danger,
//     fontSize: '14px',
//     fontWeight: '500',
//     margin: 0,
//   },
//   loadingContainer: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '60px 20px',
//     color: COLORS.textLight,
//   },
//   spinner: {
//     width: '32px',
//     height: '32px',
//     border: `3px solid ${COLORS.border}`,
//     borderTop: `3px solid ${COLORS.primary}`,
//     borderRadius: '50%',
//     animation: 'spin 1s linear infinite',
//     marginBottom: '16px',
//   },
//   emptyState: {
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//     padding: '80px 20px',
//     textAlign: 'center',
//   },
//   emptyStateIcon: {
//     fontSize: '48px',
//     marginBottom: '16px',
//   },
//   emptyStateTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     color: COLORS.dark,
//     margin: '0 0 8px 0',
//   },
//   emptyStateText: {
//     fontSize: '14px',
//     color: COLORS.textLight,
//     margin: '0 0 24px 0',
//     maxWidth: '300px',
//   },
//   emptyStateButton: {
//     padding: '12px 24px',
//     border: 'none',
//     borderRadius: '8px',
//     backgroundColor: COLORS.primary,
//     color: COLORS.white,
//     fontSize: '14px',
//     fontWeight: '500',
//     cursor: 'pointer',
//     transition: 'all 0.2s ease',
//   },
// };

// // Add CSS for animations
// const styleSheet = document.styleSheets[0];
// styleSheet.insertRule(`
//   @keyframes spin {
//     0% { transform: rotate(0deg); }
//     100% { transform: rotate(360deg); }
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   input[type="checkbox"]:checked + .toggleSlider {
//     background-color: ${COLORS.primary};
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   input[type="checkbox"]:checked + .toggleSlider:before {
//     transform: translateX(20px);
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .toggleSlider:before {
//     position: absolute;
//     content: "";
//     height: 16px;
//     width: 16px;
//     left: 4px;
//     bottom: 4px;
//     background-color: white;
//     transition: 0.4s;
//     border-radius: 50%;
//   }
// `, styleSheet.cssRules.length);

// // Hover effects
// styleSheet.insertRule(`
//   .addButton:hover, .saveButton:hover {
//     background-color: ${COLORS.primaryDark};
//     transform: translateY(-1px);
//     box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .cancelButton:hover, .filterButton:hover, .editButton:hover {
//     background-color: #F8FAFC;
//     border-color: ${COLORS.primary};
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .deleteButton:hover {
//     background-color: ${COLORS.danger};
//     color: white;
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .tableRow:hover {
//     background-color: #F8FAFC;
//   }
// `, styleSheet.cssRules.length);

// styleSheet.insertRule(`
//   .formInput:focus {
//     outline: none;
//     border-color: ${COLORS.primary};
//     box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
//   }
// `, styleSheet.cssRules.length);

// export default ElectionList;

import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getelectiontype,
  createelectiontype,
  updateelectiontype,
  deleteelectiontype,
} from "../actions/electionAction"; // Adjust path as needed

const COLORS = {
  primary: "#3B82F6",
  primaryDark: "#1D4ED8",
  secondary: "#64748B",
  success: "#10B981",
  danger: "#EF4444",
  warning: "#F59E0B",
  light: "#F8FAFC",
  dark: "#1E293B",
  border: "#E2E8F0",
  text: "#475569",
  textLight: "#94A3B8",
  white: "#FFFFFF",
};

const ElectionList = () => {
  const dispatch = useDispatch();

  const electiontypeList = useSelector(
    (state) => state.elections?.electiontypeList || []
  );
  const loading = useSelector((state) => state.elections?.loading) || false;
  const error = useSelector((state) => state.elections?.error) || null;

  const [searchQuery, setSearchQuery] = useState("");
  const [addModalVisible, setAddModalVisible] = useState(false);
  const [year, setYear] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("active");

  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editingElection, setEditingElection] = useState(null);

  const [filterModalVisible, setFilterModalVisible] = useState(false);
  const [activeFilterType, setActiveFilterType] = useState("name");
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    dispatch(getelectiontype());
  }, [dispatch]);

  const filteredElections = useMemo(() => {
    let data = Array.isArray(electiontypeList) ? electiontypeList : [];
    if (searchQuery) {
      const queryLower = searchQuery.toLowerCase();
      data = data.filter(
        (item) =>
          item.name.toLowerCase().includes(queryLower) ||
          item.year.toString().toLowerCase().includes(queryLower) ||
          item.id.toString().toLowerCase().includes(queryLower)
      );
    }
    if (filterValue) {
      const filterLower = filterValue.toLowerCase().trim();
      data = data.filter((item) => {
        const valueToCompare =
          {
            id: item.id.toString(),
            name: item.name,
            year: item.year.toString(),
          }[activeFilterType];
        return valueToCompare?.toLowerCase().includes(filterLower);
      });
    }
    return data.sort((a, b) => b.id - a.id);
  }, [searchQuery, electiontypeList, activeFilterType, filterValue]);

  const clearAddModal = () => {
    setYear("");
    setName("");
    setStatus("active");
    setAddModalVisible(false);
  };

  const handleClearFilter = () => {
    setActiveFilterType("name");
    setFilterValue("");
    setFilterModalVisible(false);
  };

  const handleAddElection = async () => {
    if (!year.trim() || !name.trim()) {
      alert("Error: Fields cannot be empty");
      return;
    }
    if (!/^\d{4}$/.test(year)) {
      alert("Error: Invalid year format");
      return;
    }
    const newItem = {
      name,
      year: parseInt(year),
      status,
    };
    await dispatch(createelectiontype(newItem));
    await dispatch(getelectiontype());
    clearAddModal();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this election?")) {
      await dispatch(deleteelectiontype({ id }));
      await dispatch(getelectiontype());
    }
  };

  const handleEdit = (item) => {
    setEditingElection({ ...item });
    setEditModalVisible(true);
  };

  const handleUpdate = async () => {
    if (!editingElection.name.trim() || !editingElection.year.toString().trim()) {
      alert("Error: Fields cannot be empty");
      return;
    }
    if (!/^\d{4}$/.test(editingElection.year.toString())) {
      alert("Error: Invalid year format");
      return;
    }
    await dispatch(updateelectiontype(editingElection));
    await dispatch(getelectiontype());
    setEditModalVisible(false);
    setEditingElection(null);
  };

  const toggleStatus = async (item) => {
    const updated = {
      ...item,
      is_active: item.is_active === 1 ? 0 : 1,
    };
    await dispatch(updateelectiontype(updated));
    await dispatch(getelectiontype());
  };

  const StatusBadge = ({ active }) => (
    <span
      style={{
        ...styles.statusBadge,
        ...(active ? styles.statusActive : styles.statusInactive),
      }}
    >
      {active ? "Active" : "Inactive"}
    </span>
  );

  const Modal = ({ visible, onClose, children, title }) => {
    if (!visible) return null;
    return (
      <div style={styles.modalBackdrop}>
        <div style={styles.modalView}>
          <div style={styles.modalHeader}>
            <h2 style={styles.modalTitle}>{title}</h2>
            <button style={styles.closeButton} onClick={onClose}>
              ×
            </button>
          </div>
          {children}
        </div>
      </div>
    );
  };

  const FilterTypeButton = ({ type, active, onClick }) => (
    <button
      onClick={onClick}
      style={{
        ...styles.filterTypeButton,
        ...(active ? styles.filterTypeButtonActive : {}),
      }}
    >
      {type.charAt(0).toUpperCase() + type.slice(1)}
    </button>
  );

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>Election Management</h1>
          <p style={styles.subtitle}>Manage and monitor all election types</p>
        </div>
        <button onClick={() => setAddModalVisible(true)} style={styles.addButton}>
          <span style={styles.addButtonIcon}>+</span> Add Election
        </button>
      </div>

      <div style={styles.controlsContainer}>
        <div style={styles.searchContainer}>
          <div style={styles.searchWrapper}>
            <input
              type="text"
              placeholder="Search elections..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={styles.searchInput}
            />
            <span style={styles.searchIcon}>🔍</span>
          </div>
          <button onClick={() => setFilterModalVisible(true)} style={styles.filterButton}>
            <span style={styles.filterIcon}>⏷</span> Filters
          </button>
        </div>

        <div style={styles.statsContainer}>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>{electiontypeList.length}</span>
            <span style={styles.statLabel}>Total</span>
          </div>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>
              {electiontypeList.filter((e) => e.is_active === 1).length}
            </span>
            <span style={styles.statLabel}>Active</span>
          </div>
        </div>
      </div>

      {error && (
        <div style={styles.errorContainer}>
          <div style={styles.errorIcon}>⚠️</div>
          <p style={styles.errorText}>Error: {error}</p>
        </div>
      )}

      <div style={styles.tableContainer}>
        {loading && filteredElections.length === 0 ? (
          <div style={styles.loadingContainer}>
            <div style={styles.spinner}></div>
            <p>Loading elections...</p>
          </div>
        ) : filteredElections.length === 0 ? (
          <div style={styles.emptyState}>
            <div style={styles.emptyStateIcon}>📊</div>
            <h3 style={styles.emptyStateTitle}>No elections found</h3>
            <p style={styles.emptyStateText}>
              {searchQuery || filterValue
                ? "Try adjusting your search or filter criteria"
                : "Get started by creating your first election"}
            </p>
            <button style={styles.emptyStateButton} onClick={() => setAddModalVisible(true)}>
              Add Election
            </button>
          </div>
        ) : (
          <table style={styles.table}>
            <thead style={styles.tableHeader}>
              <tr>
                <th style={styles.tableHeaderCell}>ID</th>
                <th style={styles.tableHeaderCell}>Name</th>
                <th style={styles.tableHeaderCell}>Year</th>
                <th style={styles.tableHeaderCell}>Status</th>
                <th style={styles.tableHeaderCell}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredElections.map((item) => (
                <tr key={item.id} style={styles.tableRow}>
                  <td style={styles.tableCell}>
                    <span style={styles.idBadge}>#{item.id}</span>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.nameCell}>
                      <span style={styles.nameText}>{item.name}</span>
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <span style={styles.yearText}>{item.year}</span>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.statusCell}>
                      <StatusBadge active={item.is_active === 1} />
                      <label style={styles.toggleSwitch}>
                        <input
                          type="checkbox"
                          checked={item.is_active === 1}
                          onChange={() => toggleStatus(item)}
                          style={styles.toggleInput}
                        />
                        <span style={styles.toggleSlider}></span>
                      </label>
                    </div>
                  </td>
                  <td style={styles.tableCell}>
                    <div style={styles.actionButtons}>
                      <button style={styles.editButton} onClick={() => handleEdit(item)} title="Edit">
                        Edit
                      </button>
                      <button style={styles.deleteButton} onClick={() => handleDelete(item.id)} title="Delete">
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <Modal visible={addModalVisible} onClose={clearAddModal} title="Create New Election">
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Election Year</label>
          <input
            type="number"
            placeholder="Enter election year (e.g., 2024)"
            maxLength={4}
            value={year}
            onChange={(e) => setYear(e.target.value)}
            style={styles.formInput}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Election Name</label>
          <input
            type="text"
            placeholder="Enter election name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            style={styles.formInput}
          />
        </div>
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Status</label>
          <select value={status} onChange={(e) => setStatus(e.target.value)} style={styles.formInput}>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div style={styles.modalActions}>
          <button onClick={clearAddModal} style={styles.cancelButton}>
            Cancel
          </button>
          <button onClick={handleAddElection} style={styles.saveButton}>
            Create Election
          </button>
        </div>
      </Modal>

      <Modal visible={editModalVisible} onClose={() => setEditModalVisible(false)} title="Edit Election">
        {editingElection && (
          <>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Election Year</label>
              <input
                type="number"
                placeholder="Enter election year"
                maxLength={4}
                value={editingElection.year}
                onChange={(e) => setEditingElection({ ...editingElection, year: e.target.value })}
                style={styles.formInput}
              />
            </div>
            <div style={styles.formGroup}>
              <label style={styles.formLabel}>Election Name</label>
              <input
                type="text"
                placeholder="Enter election name"
                value={editingElection.name}
                onChange={(e) => setEditingElection({ ...editingElection, name: e.target.value })}
                style={styles.formInput}
              />
            </div>
            <div style={styles.modalActions}>
              <button onClick={() => setEditModalVisible(false)} style={styles.cancelButton}>
                Cancel
              </button>
              <button onClick={handleUpdate} style={styles.saveButton}>
                Save Changes
              </button>
            </div>
          </>
        )}
      </Modal>

      <Modal visible={filterModalVisible} onClose={() => setFilterModalVisible(false)} title="Filter Elections">
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Filter By</label>
          <div style={styles.filterTypeContainer}>
            {["name", "id", "year"].map((type) => (
              <FilterTypeButton
                key={type}
                type={type}
                active={activeFilterType === type}
                onClick={() => setActiveFilterType(type)}
              />
            ))}
          </div>
        </div>
        <div style={styles.formGroup}>
          <label style={styles.formLabel}>Filter Value</label>
          <input
            type={activeFilterType !== "name" ? "number" : "text"}
            placeholder={`Enter ${activeFilterType} to filter...`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            style={styles.formInput}
          />
        </div>
        <div style={styles.modalActions}>
          <button onClick={handleClearFilter} style={styles.cancelButton}>
            Clear Filters
          </button>
          <button onClick={() => setFilterModalVisible(false)} style={styles.saveButton}>
            Apply Filters
          </button>
        </div>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#F8FAFC",
    padding: "32px",
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "32px",
  },
  headerContent: {
    flex: 1,
  },
  title: {
    fontSize: "32px",
    fontWeight: "700",
    color: COLORS.dark,
    margin: "0 0 8px 0",
  },
  subtitle: {
    fontSize: "16px",
    color: COLORS.textLight,
    margin: 0,
  },
  addButton: {
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(59, 130, 246, 0.2)",
  },
  addButtonIcon: {
    fontSize: "18px",
    fontWeight: "bold",
  },
  controlsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    gap: "24px",
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
  },
  searchWrapper: {
    position: "relative",
    flex: 1,
    maxWidth: "400px",
  },
  searchInput: {
    width: "100%",
    padding: "12px 16px 12px 40px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: COLORS.white,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
  },
  searchIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: COLORS.textLight,
  },
  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "12px 16px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    backgroundColor: COLORS.white,
    color: COLORS.text,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  filterIcon: {
    fontSize: "16px",
  },
  statsContainer: {
    display: "flex",
    gap: "16px",
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "16px 20px",
    backgroundColor: COLORS.white,
    borderRadius: "8px",
    border: `1px solid ${COLORS.border}`,
    minWidth: "80px",
  },
  statNumber: {
    fontSize: "20px",
    fontWeight: "700",
    color: COLORS.dark,
  },
  statLabel: {
    fontSize: "12px",
    color: COLORS.textLight,
    fontWeight: "500",
  },
  tableContainer: {
    backgroundColor: COLORS.white,
    borderRadius: "12px",
    border: `1px solid ${COLORS.border}`,
    overflow: "hidden",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  tableHeader: {
    backgroundColor: "#F8FAFC",
    borderBottom: `1px solid ${COLORS.border}`,
  },
  tableHeaderCell: {
    padding: "16px 20px",
    textAlign: "left",
    fontSize: "12px",
    fontWeight: "600",
    color: COLORS.textLight,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  tableRow: {
    borderBottom: `1px solid ${COLORS.border}`,
  },
  tableCell: {
    padding: "20px",
    fontSize: "14px",
    color: COLORS.text,
  },
  idBadge: {
    backgroundColor: "#F1F5F9",
    color: COLORS.text,
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "600",
  },
  nameCell: {
    display: "flex",
    alignItems: "center",
  },
  nameText: {
    fontWeight: "500",
    color: COLORS.dark,
  },
  yearText: {
    fontWeight: "600",
    color: COLORS.dark,
  },
  statusCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  statusBadge: {
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "600",
  },
  statusActive: {
    backgroundColor: "#D1FAE5",
    color: "#065F46",
  },
  statusInactive: {
    backgroundColor: "#FEE2E2",
    color: "#991B1B",
  },
  toggleSwitch: {
    position: "relative",
    display: "inline-block",
    width: "44px",
    height: "24px",
  },
  toggleInput: {
    opacity: 0,
    width: 0,
    height: 0,
  },
  toggleSlider: {
    position: "absolute",
    cursor: "pointer",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "#CBD5E1",
    transition: "0.4s",
    borderRadius: "24px",
  },
  actionButtons: {
    display: "flex",
    gap: "8px",
  },
  editButton: {
    padding: "8px 16px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "6px",
    backgroundColor: COLORS.white,
    color: COLORS.text,
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  deleteButton: {
    padding: "8px 16px",
    border: `1px solid ${COLORS.danger}`,
    borderRadius: "6px",
    backgroundColor: COLORS.white,
    color: COLORS.danger,
    fontSize: "12px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  modalBackdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
  },
  modalView: {
    backgroundColor: COLORS.white,
    borderRadius: "12px",
    width: "100%",
    maxWidth: "480px",
    boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "24px 24px 0 24px",
  },
  modalTitle: {
    fontSize: "20px",
    fontWeight: "600",
    color: COLORS.dark,
    margin: 0,
  },
  closeButton: {
    background: "none",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: COLORS.textLight,
    padding: 0,
    width: "32px",
    height: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4px",
    transition: "background-color 0.2s ease",
  },
  formGroup: {
    marginBottom: "20px",
    padding: "0 24px",
  },
  formLabel: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: COLORS.dark,
  },
  formInput: {
    width: "100%",
    padding: "12px 16px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: COLORS.white,
    boxSizing: "border-box",
    transition: "border-color 0.2s ease",
  },
  modalActions: {
    display: "flex",
    gap: "12px",
    padding: "24px",
    borderTop: `1px solid ${COLORS.border}`,
  },
  cancelButton: {
    flex: 1,
    padding: "12px 16px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    backgroundColor: COLORS.white,
    color: COLORS.text,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveButton: {
    flex: 1,
    padding: "12px 16px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  filterTypeContainer: {
    display: "flex",
    gap: "8px",
  },
  filterTypeButton: {
    flex: 1,
    padding: "12px 16px",
    border: `1px solid ${COLORS.border}`,
    borderRadius: "8px",
    backgroundColor: COLORS.white,
    color: COLORS.text,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
  },
  filterTypeButtonActive: {
    backgroundColor: COLORS.primary,
    borderColor: COLORS.primary,
    color: COLORS.white,
  },
  errorContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 20px",
    backgroundColor: "#FEF2F2",
    border: `1px solid ${COLORS.danger}`,
    borderRadius: "8px",
    marginBottom: "24px",
  },
  errorIcon: {
    fontSize: "16px",
  },
  errorText: {
    color: COLORS.danger,
    fontSize: "14px",
    fontWeight: "500",
    margin: 0,
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "60px 20px",
    color: COLORS.textLight,
  },
  spinner: {
    width: "32px",
    height: "32px",
    border: `3px solid ${COLORS.border}`,
    borderTop: `3px solid ${COLORS.primary}`,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "80px 20px",
    textAlign: "center",
  },
  emptyStateIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  emptyStateTitle: {
    fontSize: "18px",
    fontWeight: "600",
    color: COLORS.dark,
    margin: "0 0 8px 0",
  },
  emptyStateText: {
    fontSize: "14px",
    color: COLORS.textLight,
    margin: "0 0 24px 0",
    maxWidth: "300px",
  },
  emptyStateButton: {
    padding: "12px 24px",
    border: "none",
    borderRadius: "8px",
    backgroundColor: COLORS.primary,
    color: COLORS.white,
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

export default ElectionList;


